import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes__default from 'prop-types';

var _excluded = ["title", "pathRest"];
var IconTrain = function IconTrain(_ref) {
  var title = _ref.title,
    pathRest = _ref.pathRest,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: "hci-svg-train"
  }, rest), title && /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", _extends({
    d: "M8.5 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0m6 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m7.45 9H19.3l-.88-1H5.58l-.88 1H2.05l5.42-6.2A3 3 0 0 1 5.5 13V5a3 3 0 0 1 3-3h7a3 3 0 0 1 3 3v8a3 3 0 0 1-1.97 2.8zM7.5 8h9V5c0-.54-.46-1-1-1h-7c-.54 0-1 .46-1 1zm0 5c0 .54.46 1 1 1h7c.54 0 1-.46 1-1v-3h-9zm6.55 3h-4.1l-.87 1h5.84zm2.62 3-.87-1H8.2l-.87 1z"
  }, pathRest)));
};
IconTrain.displayName = 'InlineIcon(IconTrain)';
IconTrain.propTypes = {
  title: PropTypes__default.string,
  pathRest: PropTypes__default.object
};

export { IconTrain };
